import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const sucesso = useLocation().state?.sucesso;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErro('');
    try {
      await login(email, senha);
      window.location.href = '/dashboard';
    } catch (err) {
      setErro(err.response?.data?.error || 'Email ou senha inválidos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#F0F3F7',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'DM Sans',system-ui,sans-serif",
    }}>
      <div style={{ width: '100%', maxWidth: '400px', padding: '0 20px' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
            <div style={{ width: '44px', height: '44px', background: '#1A3A5C', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700', fontSize: '18px', color: '#fff' }}>
              A+
            </div>
            <span style={{ fontSize: '28px', fontWeight: '700', color: '#1A3A5C', letterSpacing: '-0.5px' }}>AutoMais</span>
          </div>
          <div style={{ fontSize: '14px', color: '#6B7A8D' }}>Sistema de Gestão</div>
        </div>

        {/* Card */}
        <div style={{ background: '#fff', borderRadius: '12px', border: '0.5px solid rgba(26,58,92,0.12)', padding: '32px' }}>
          <div style={{ fontSize: '18px', fontWeight: '700', color: '#1C2533', marginBottom: '6px' }}>Bem-vindo</div>
          <div style={{ fontSize: '13px', color: '#6B7A8D', marginBottom: '24px' }}>Faça login para continuar</div>

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '14px' }}>
              <label style={{ color: '#6B7A8D', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                Email
              </label>
              <input
                type='email'
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder='seu@email.com'
                required
                style={{ width: '100%', padding: '10px 12px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '8px', color: '#1C2533', fontSize: '14px', fontFamily: "'DM Sans',system-ui,sans-serif", boxSizing: 'border-box', outline: 'none' }}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ color: '#6B7A8D', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                Senha
              </label>
              <input
                type='password'
                value={senha}
                onChange={e => setSenha(e.target.value)}
                placeholder='••••••••'
                required
                style={{ width: '100%', padding: '10px 12px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '8px', color: '#1C2533', fontSize: '14px', fontFamily: "'DM Sans',system-ui,sans-serif", boxSizing: 'border-box', outline: 'none' }}
              />
            </div>

            <div style={{ textAlign: 'right', marginTop: '-12px', marginBottom: '16px' }}>
              <Link to='/recuperar-senha' style={{ fontSize: '12px', color: '#1A3A5C', fontWeight: '600', textDecoration: 'none' }}>
                Esqueci minha senha
              </Link>
            </div>

            {sucesso && !erro && (
              <div style={{ background: '#E8F6EE', border: '0.5px solid #1E8449', borderRadius: '8px', padding: '10px 14px', marginBottom: '16px', fontSize: '13px', color: '#1E8449' }}>
                {sucesso}
              </div>
            )}

            {erro && (
              <div style={{ background: '#FDECEA', border: '0.5px solid #C0392B', borderRadius: '8px', padding: '10px 14px', marginBottom: '16px', fontSize: '13px', color: '#C0392B' }}>
                {erro}
              </div>
            )}

            <button
              type='submit'
              disabled={loading}
              style={{ width: '100%', padding: '12px', background: loading ? '#6B7A8D' : '#1A3A5C', border: 'none', borderRadius: '8px', color: '#fff', fontSize: '15px', fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer', fontFamily: "'DM Sans',system-ui,sans-serif", transition: 'background 0.15s' }}>
              {loading ? 'Entrando...' : 'Entrar'}
            </button>
          </form>
        </div>

        <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '12px', color: '#9AA3AE' }}>
          AutoMais · Sistema de Gestão para Motos
        </div>
      </div>
    </div>
  );
}
